import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { DiscountKind } from '@skylab-shared/dataModel';
import { fillPlaceholders, MS_PER_MINUTE } from '@skylab-shared/utils';

export interface ProductsRelatedToSalePatternsQueryParameters {
    id: number;
}

export interface ProductsRelatedToSalePatternsModel {
    itemId: number;
    templateId: number;
    templateName: string;
    currencyId: number;
    discountKind: DiscountKind;
    discountValue: number;
    netPriceBeforeDiscount: number;
    grossPriceBeforeDiscount: number;
}

export class ProductsRelatedToSalePatternsQuery extends Query<ProductsRelatedToSalePatternsModel[]> {
    constructor(readonly parameters: ProductsRelatedToSalePatternsQueryParameters) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductsRelatedToSalePatternsQuery)
export class ProductsRelatedToSalePatternsQueryHandler implements QueryHandler<ProductsRelatedToSalePatternsQuery, ProductsRelatedToSalePatternsModel[]> {
    #Url = TaggedUrl.join('products/:id/documentTemplates', [Tags.Api]);

    #http =  inject(Http) as HttpService;

    async handleAsync(query: ProductsRelatedToSalePatternsQuery): Promise<ProductsRelatedToSalePatternsModel[]> {
        const url = fillPlaceholders(this.#Url, { id: query.parameters.id });
        const { data } = await this.#http.get<ProductsRelatedToSalePatternsModel[]>(url, { timeout: MS_PER_MINUTE });

        return data.map(item => ({
            itemId: item.itemId,
            templateId: item.templateId,
            templateName: item.templateName,
            currencyId: item.currencyId,
            discountKind: item.discountKind,
            discountValue: item.discountValue,
            netPriceBeforeDiscount: item.netPriceBeforeDiscount,
            grossPriceBeforeDiscount: item.grossPriceBeforeDiscount
        }));
    }
}
